import { supabase } from '../lib/supabase';

// Buscar os termos de uso (sempre retorna o único registro)
export const fetchTermosUso = async () => {
  try {
    const { data, error } = await supabase
      .from('termos_uso')
      .select('*')
      .order('updated_at', { ascending: false })
      .limit(1)
      .single();

    if (error && error.code !== 'PGRST116') { // PGRST116 = no rows returned
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Erro ao buscar termos de uso:', error);
    throw error;
  }
};

// Criar ou atualizar os termos de uso
export const saveTermosUso = async (conteudo) => {
  try {
    // Primeiro, verificar se já existe um registro
    const existingTerms = await fetchTermosUso();

    if (existingTerms) {
      // Atualizar o registro existente
      const { data, error } = await supabase
        .from('termos_uso')
        .update({ conteudo })
        .eq('id', existingTerms.id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } else {
      // Criar novo registro
      const { data, error } = await supabase
        .from('termos_uso')
        .insert([{ conteudo, versao: 1 }])
        .select()
        .single();

      if (error) throw error;
      return data;
    }
  } catch (error) {
    console.error('Erro ao salvar termos de uso:', error);
    throw error;
  }
};

// Função para limpar HTML e obter texto puro (para preview)
export const stripHtml = (html) => {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

// Função para formatar data
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Função para contar palavras no conteúdo
export const countWords = (html) => {
  const text = stripHtml(html);
  return text.trim() ? text.trim().split(/\s+/).length : 0;
};

// Função para estimar tempo de leitura (baseado em 200 palavras por minuto)
export const estimateReadingTime = (html) => {
  const wordCount = countWords(html);
  const readingTime = Math.ceil(wordCount / 200);
  return readingTime;
};
